import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../programs/Programs.css";
import { useRef } from "react";

const CompanyClientsList = (props) => {
  const navigate = useNavigate();
  // const userBusinessID =
  //   localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData"))
  //     ? JSON.parse(localStorage.getItem("userData")).business_id
  //     : -1;
  const wrapperRef = useRef("");
  useOutsideDotClose(wrapperRef);
  function useOutsideDotClose(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          const data = [...props.clientsData];
          for (let m of data) {
            m.modalOpened = false;
          }
          props.updateClientData(data);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
      // eslint-disable-next-line
    }, [ref, props]);
  }

  return props.clientsData.length > 0 ? (
    <div className="table_component_main_container">
      <div className="programs_top_hold">
        <input
          type="text"
          ref={props.search}
          placeholder={"Search"}
          className="programs_search_bar"
          onChange={() => props.updateSearchQuery(props.search.current.value)}
        />
        <div
            className="programs_new_btn"
            onClick={() => {
              navigate("/add-new-client");
              props.actSidebar(false);
            }}
          >
            Add Client
          </div>
        {/* <div className="top_hold_buttons">
          <div className="programs_menu"></div>
        </div> */}
      </div>

      <div className="table_scrollable_container_new">
        <div className="table_scrollable_inner_container">
          <div className="programs_table">
            <div className="programs_cols">
              <div className="programs_col_info">
                <div className="programs_col_name">Organization Type</div>
                <div
                  className="programs_col_icon"
                  onClick={() =>
                    props.handleSorting("companyType", props.clientsData)
                  }
                ></div>
              </div>
              <div className="programs_col_info">
                <div className="programs_col_name">Organization Name</div>
                <div
                  className="programs_col_icon"
                  onClick={() =>
                    props.handleSorting("companyName", props.clientsData)
                  }
                ></div>
              </div>
              <div className="programs_col_info">
                <div className="programs_col_name">Admin First Name</div>
                <div
                  className="programs_col_icon"
                  onClick={() =>
                    props.handleSorting("firstName", props.clientsData)
                  }
                ></div>
              </div>

              <div className="programs_col_info">
                <div className="programs_col_name">Admin Last Name</div>
                <div
                  className="programs_col_icon"
                  onClick={() =>
                    props.handleSorting("lastName", props.clientsData)
                  }
                ></div>
              </div>
              <div className="programs_col_info">
                <div className="programs_col_name">Admin Email</div>
                <div
                  className="programs_col_icon"
                  onClick={() =>
                    props.handleSorting("email", props.clientsData)
                  }
                ></div>
              </div>
            </div>
            </div>
            <div className="tbl_content_hold">
              {props.clientsData &&
                props.clientsData.map((item, i) => (
                  <div
                    key={i}
                    className="programs_tbl_content current_patient_mark"
                  >
                    <div className="programs_tbl_row client-list_row">
                      <div className="programs_tbl_col_contain">
                        <div className="programs_tbl_col">
                          {item.companyType}
                        </div>
                      </div>
                      <div className="programs_tbl_col_contain">
                        <div className="programs_tbl_col">
                          {item.companyName}
                        </div>
                      </div>
                      <div className="programs_tbl_col_contain">
                        <div className="programs_tbl_col">{item.firstName}</div>
                      </div>
                      <div className="programs_tbl_col_contain">
                        <div className="programs_tbl_col">{item.lastName}</div>
                      </div>
                      <div className="programs_tbl_col_contain">
                        <div className="programs_tbl_col">{item.email}</div>
                      </div>
                      {!item.modalOpened ? (
                        <div
                          className="programs_tbl_col programs_tbl_col_last list-options"
                          style={{ height: 0 }}
                          onClick={() => props.modalOpened(i)}
                        >
                          ...
                        </div>
                      ) : (
                        <div
                          className="programs_tbl_col programs_tbl_col_last list-options"
                          style={{ height: 0, pointerEvents: "none" }}
                          onClick={() => props.modalOpened(i)}
                        >
                          ...
                        </div>
                      )}
                      {item.modalOpened && (
                        <div
                          className={
                            i === props.clientsData.length - 1
                              ? "workouts-list__container_last hexercise-list__container"
                              : "client-list__container hexercise-list__container"
                          }
                          ref={wrapperRef}
                        >
                          <Link
                            to={"/edit-client/" + item.companyId}
                            style={{ display: "block", textDecoration: "none" }}
                            className="client-list-option"
                          >
                            <div>Edit Client</div>
                          </Link>
                          <div
                            className="client-list-option client-list-option__delete"
                            onClick={() =>
                              props.handleDeleteModal(item.companyId)
                            }
                          >
                            Delete Client
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              {props.modalVisible && (
                <div className="dlt_wrapper">
                  <div className="dbl_place_on_page">
                    <div className="dlt_surround">
                      <div className="dlt_title">Delete Client</div>
                      <div className="dlt_description">
                        <p>Do you want to delete Client?</p>
                      </div>
                      <div className="dlt_exit_btm">
                        <div
                          className="dlt_exit_btn dlt_eb_first"
                          onClick={props.closeDeleteModal}
                        >
                          Cancel
                        </div>
                        <div
                          className="dlt_exit_btn dlt_eb_scnd"
                          onClick={() => props.handleDeleteClient()}
                        >
                          Delete
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="table_component_main_container">
      <div className="programs_top_hold">
        <input
          type="text"
          ref={props.search}
          placeholder={"Search"}
          className="programs_search_bar"
          onChange={() => props.updateSearchQuery(props.search.current.value)}
        />
        <div
            className="programs_new_btn"
            onClick={() => {
              navigate("/add-new-client");
              props.actSidebar(false);
            }}
          >
            Add Client
          </div>
      </div>

      <div className="table_scrollable_container_new">
        <div className="table_scrollable_inner_container">
                <div className="programs_table_no_content">
                  <div className="no_content_notice_contain">
              {props.contentLoaded ? (
                <>
                  <div className="programs_no_results_img"></div>
                  <div className="programs_no_res_main">
                    {props.selectedTab === "Clients"
                      ? "You have no active clients"
                      : ""}
                  </div>
                  <div className="programs_no_res_elab">
                    You have 0{" "}
                    {props.selectedTab === "Clients" ? "clients added" : ""}
                  </div>

                  <div style={{flex: 1, display: 'flex', justifyContent: 'center'}}>

                  <Link
                    to={
                      props.selectedTab === "Clients" ? "/add-new-client" : ""
                    }
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      className="programs_new_btn"
                      style={{ borderRadius: "99px" }}
                    >
                      {props.selectedTab === "Clients" ? "Add Client" : ""}
                    </div>
                  </Link>
                  </div>
                </>
              ) : (
                <div className="p_load"></div>
              )}
            </div>
          </div>
        </div>{" "}
      </div>
    </div>
  );
};

export default CompanyClientsList;
